// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"62478efe","453":"75e282d7"}[chunkId] + ".chunk.js";
};